"use client";
import quote from "@/assets/landingPage/testimonial/quote.svg";
import testimonialBg from "@/assets/landingPage/testimonial/testimonials-bg.png";
import { useDocumentDirection } from "@/hooks/useDocumentDirection";
import { parseColorTextToJSX } from "@/utils/utils";
import { Icon } from "@iconify/react";
import Image from "next/image";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import TextReveal from "../animation/TextReveal";

const Testimonials = ({ data, testimonials }) => {
  const dir = useDocumentDirection();
  return (
    <div
      className="testimonials section_space_py no-repeat bg-cover w-full h-full"
      style={{ backgroundImage: `url(${testimonialBg.src})` }}
    >
      <div className="custom-container mx-auto pb-14">
        <div className="grid grid-cols-12 gap-0 lg:gap-7.5">
          <div className="col-span-12 lg:col-span-5">
            <TextReveal delay={0.2} duration={1.2} direction="left">
              <div>
                <h2 className="title-design title-design-white max-w-full sm:max-w-sm mb-4">
                  {parseColorTextToJSX(data?.testimonial_title)}
                </h2>
                <p className="paragraph-design paragraph-design-white max-w-full sm:max-w-md mb-5 lg:mb-0">
                  {data?.sub_title}
                </p>
              </div>
            </TextReveal>
          </div>
          <div className="col-span-12 lg:col-span-7">
            <TextReveal delay={0.2} duration={1.2} direction="bottom">
              <div className="relative w-full">
                <Swiper
                  spaceBetween={16}
                  slidesPerView={1}
                  modules={[Pagination, Navigation]}
                  navigation={{
                    nextEl: ".custom-next",
                    prevEl: ".custom-prev",
                  }}
                  dir={dir}
                  key={dir}
                  className="w-full"
                >
                  {testimonials.map((testimonial, index) => {
                    return (
                      <SwiperSlide key={testimonial.id}>
                        <div className="w-full">
                          <div className="mb-5">
                            <Image
                              src={quote}
                              alt="quote"
                              width={100}
                              height={100}
                              className="w-[32px] h-[32px]"
                            />
                          </div>
                          <div>
                            <p className="text-[16px] sm:text-[18px] lg:text-[20px] font-medium text-white">
                              {testimonial?.message}
                            </p>
                          </div>
                          <div className="mt-[60px] flex items-center gap-5">
                            <div className="relative">
                              <div className="relative z-[2]">
                                <Image
                                  src={testimonial?.picture}
                                  alt="quote"
                                  width={100}
                                  height={100}
                                  unoptimized
                                  className="w-[58px] h-[58px] rounded-full"
                                />
                              </div>
                              <div className="absolute -top-3 rtl:right-0 ltr:left-0 w-[58px] h-[58px] rounded-full bg-[#BAA3FF]"></div>
                            </div>
                            <div>
                              <p className="text-[16px] font-bold text-white mb-[6px]">
                                {testimonial?.name}
                              </p>
                              <p className="text-[14px] font-medium text-[rgba(255,255,255,0.80)]">
                                {testimonial?.designation}
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
                <div className="absolute -bottom-14 rtl:right-0 ltr:left-0 flex gap-3 z-10">
                  <button className="custom-prev common-swiper-btn">
                    <Icon
                      icon="lucide:arrow-left"
                      width="16"
                      height="16"
                      className="rtl:rotate-180"
                    />
                  </button>
                  <button className="custom-next common-swiper-btn">
                    <Icon
                      icon="lucide:arrow-right"
                      width="16"
                      height="16"
                      className="rtl:rotate-180"
                    />
                  </button>
                </div>
              </div>
            </TextReveal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
